import {DocumentData, QueryDocumentSnapshot, SnapshotOptions, Timestamp} from "firebase/firestore";
import {CalendarChangeLogDocument, CalendarChangeLogType} from "./CalendarChangeLogType";

function toNullableDate(value: unknown): Date | null {
    return value instanceof Timestamp ? value.toDate() : value instanceof Date ? value : null;
}

function toDate(value: unknown): Date {
    return toNullableDate(value) ?? new Date(0);
}

function toChangeType(value: unknown): CalendarChangeLogType {
    switch (value) {
        case "EVENT":
        case "START_DATE":
        case "DAY_TYPE":
        case "DESCRIPTION":
        case "IS_SUPERVISOR":
        case "IS_WAREHOUSE":
        case "IS_MONTAGE":
        case "END_DATE":
        case "REST_TIME":
        case "BONUS":
        case "FACE":
        case "NOTES":
        case "IS_CONFIRMED":
        case "DELETE":
        case "LOCK":
        case "UNLOCK":
            return value;
        default:
            return "EVENT";
    }
}

export const calendarChangeLogFBConverter = {
    fromFirestore: (
        snapshot: QueryDocumentSnapshot<DocumentData>,
        options: SnapshotOptions
    ): CalendarChangeLogDocument => {
        const data = snapshot.data(options);

        return {
            id: snapshot.id,
            changeType: toChangeType(data.changeType),
            operationId: typeof data.operationId === "string" ? data.operationId : "",
            calendarItemId: typeof data.calendarItemId === "string" ? data.calendarItemId : null,
            department: typeof data.department === "string" ? data.department : "montage",
            eventId: typeof data.eventId === "string" ? data.eventId : "",
            eventNumber: typeof data.eventNumber === "string" ? data.eventNumber : "",
            eventName: typeof data.eventName === "string" ? data.eventName : "",
            employeeId: typeof data.employeeId === "string" ? data.employeeId : null,
            employeeName: typeof data.employeeName === "string" ? data.employeeName : "",
            periodStart: toNullableDate(data.periodStart),
            periodEnd: toNullableDate(data.periodEnd),
            previousValue: typeof data.previousValue === "string" ? data.previousValue : "",
            newValue: typeof data.newValue === "string" ? data.newValue : "",
            changedAt: toDate(data.changedAt),
            changedByEmployeeId: typeof data.changedByEmployeeId === "string" ? data.changedByEmployeeId : null,
            changedByName: typeof data.changedByName === "string" ? data.changedByName : "",
        };
    },
    toFirestore: (log: CalendarChangeLogDocument): DocumentData => ({
        changeType: log.changeType,
        operationId: log.operationId,
        calendarItemId: log.calendarItemId,
        department: log.department,
        eventId: log.eventId,
        eventNumber: log.eventNumber,
        eventName: log.eventName,
        employeeId: log.employeeId,
        employeeName: log.employeeName,
        periodStart: log.periodStart,
        periodEnd: log.periodEnd,
        previousValue: log.previousValue,
        newValue: log.newValue,
        changedAt: log.changedAt,
        changedByEmployeeId: log.changedByEmployeeId,
        changedByName: log.changedByName,
    }),
};
